/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import { ab } from "../../theme"
import { useState } from "react"
import FieldGroupCheckbox from "./field-group-checkbox"

const FieldGroup = ({
  children,
  inputs,
  heading,
  displayAsCheckbox,
  checkboxName,
  checkboxValue,
  keepFlexOnMobile,
}) => {
  const [toggle, setToggle] = useState(!heading)
  let headingElement = ""
  if (heading) {
    if (!displayAsCheckbox) {
      headingElement = (
        <h4
          sx={{
            borderColor: "text",
            py: 2,
            m: 0,
            marginTop: 3,
            fontSize: 1,
            paddingLeft: 20,
            cursor: "pointer",
            position: "relative",
          }}
          role="button"
          tabIndex="0"
          onKeyPress={() => setToggle(!toggle)}
          onClick={() => setToggle(!toggle)}
        >
          <span
            className="form-arrow"
            sx={{
              variant: "form.arrow",
              left: 0,
              width: 8,
              height: 8,
              borderWidth: "1px",
            }}
          ></span>
          {heading}
        </h4>
      )
    } else {
      headingElement = (
        <div
          sx={{
            borderColor: "text",
            m: 0,
            my: 2,
            fontSize: 1,
            cursor: "pointer",
          }}
          role="button"
          tabIndex="0"
          onKeyPress={() => setToggle(!toggle)}
          onClick={() => setToggle(!toggle)}
        >
          <FieldGroupCheckbox
            label={heading}
            name={checkboxName}
            value={checkboxValue}
            checked={toggle}
          />
        </div>
      )
    }
  }

  return (
    <div
      sx={{
        borderBottom: displayAsCheckbox ? "1px solid" : "0",
        lineHeight: 1,
        flex: 1,
      }}
    >
      {headingElement}

      <div
        sx={{
          display: toggle
            ? inputs
              ? ab({ _: keepFlexOnMobile ? "flex" : "block", md: "flex" })
              : "block"
            : "none",
          flexWrap: inputs ? "wrap" : "nowrap",
          pb: displayAsCheckbox ? 4 : "0",
          "& > div": {
            borderRadius: "20px",
            minWidth: 0,
            marginRight: inputs
              ? ab({ _: keepFlexOnMobile ? "24px" : "0", md: "24px" })
              : 0,
            "&:last-child": {
              border: "0 none",
              marginRight: 0,
            },
          },
        }}
      >
        {children}
      </div>
    </div>
  )
}

FieldGroup.propTypes = {
  children: PropTypes.node,
  displayAsCheckbox: PropTypes.bool,
  checkboxName: PropTypes.string,
  checkboxValue: PropTypes.string,
  keepFlexOnMobile: PropTypes.bool,
  inputs: PropTypes.bool,
  heading: PropTypes.string,
  flex: PropTypes.string,
  mdFlex: PropTypes.string,
}

export default FieldGroup
